module.exports = __webpack_public_path__ + "static/img/screen.dec4105b.png";